import { utils } from '@hh/global.js'

const { isMobile } = utils

class HHFocalPoint extends HTMLElement {
  constructor() {
    super()

    this.initLoad = true

    this.showContents = this.showContents.bind(this)
    this.drawPosition = this.drawPosition.bind(this)
    this.drawLine = this.drawLine.bind(this)
    this.drawContents = this.drawContents.bind(this)
    this.resetPoints = this.resetPoints.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  connectedCallback() {
    this.$section = document.querySelector(
      `#Image-with-focal-points-${this.dataset.section}`
    )
    this.index = this.dataset.index
    this.xPos = Number(this.dataset.xPos)
    this.yPos = Number(this.dataset.yPos)
    this.xPosMobile = Number(this.dataset.xPosMobile)
    this.yPosMobile = Number(this.dataset.yPosMobile)

    this.$point = this.querySelector('.image-with-focal-point')
    this.$contents = this.querySelector('.image-with-focal-point__contents')
    this.$title = this.querySelector('.image-with-focal-point__title')
    this.$description = this.querySelector(
      '.image-with-focal-point__description'
    )

    this.$point.style.setProperty('--hh-focal-point-line-width', 0)
    this.$point.style.setProperty('--hh-focal-point-line-height', 0)

    this.drawPosition()
    this.$point.addEventListener('mouseover', this.showContents)
    this.$point.addEventListener('keydown', this.onKeydown)
    window.addEventListener('resize', this.handleResize)
  }

  disconnectedCallback() {
    this.$point.removeEventListener('mouseover', this.showContents)
    this.$point.removeEventListener('keydown', this.onKeydown)
    window.removeEventListener('resize', this.handleResize)
  }

  onKeydown(e) {
    if (e.code.toUpperCase() === 'ENTER') {
      this.showContents()
    }
  }

  handleResize() {
    this.drawPosition()
  }

  drawPosition() {
    this.initLoad = true
    if (!isMobile()) {
      this.$point.style.top = `${this.yPos}%`
      this.$point.style.left = `${this.xPos}%`
    } else {
      this.$point.style.top = `${this.yPosMobile}%`
      this.$point.style.left = `${this.xPosMobile}%`
    }
    if (this.$point.classList.contains('active')) {
      this.drawLine()
      this.drawContents()
    }
  }

  drawLine() {
    if (!isMobile()) {
      this.$point.style.setProperty(
        '--hh-focal-point-line-width',
        `calc(${this.xPos}vw - var(--focal-point-padding))`
      )
    } else {
      const sectionHeight = this.$section?.getBoundingClientRect().height
      const pointHeight = this.$point.getBoundingClientRect().height
      const contentHeight = this.$contents.getBoundingClientRect().height
      const calcHeight =
        sectionHeight * ((100 - this.yPosMobile) / 100) -
        contentHeight -
        pointHeight
      this.$point.style.setProperty(
        '--hh-focal-point-line-height',
        `calc(${calcHeight}px - var(--hh-spacing-4))`
      )
    }
  }

  drawContents() {
    if (!isMobile()) {
      this.$title.style.bottom = `calc(${
        100 - this.yPos
      }% + var(--hh-spacing-2) - 12px)`
      this.$description.style.top = `calc(${this.yPos}% + var(--hh-spacing-2) + 8px)`
    }
    this.$contents.classList.add('fadein')
    if (!this.initLoad) {
      this.$description.focus()
    }
  }

  resetPoints() {
    this.$section.querySelectorAll('hh-focal-point').forEach((item) => {
      if (item.dataset.index !== this.index) {
        item.querySelector('.image-with-focal-point').classList.remove('active')
        item
          .querySelector('.image-with-focal-point__contents')
          .classList.remove('fadein')
        item.style.setProperty('--hh-focal-point-line-width', 0)
        item.style.setProperty('--hh-focal-point-line-height', 0)
      }
    })
  }

  showContents() {
    if (this.$point.classList.contains('active')) return
    this.initLoad = false
    this.resetPoints()

    this.$point.classList.add('active')
    this.drawLine()
    this.drawContents()
  }
}

customElements.define('hh-focal-point', HHFocalPoint)
